<template>
  <svg
    width="113"
    height="127"
    viewBox="0 0 113 127"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity="0.6">
      <circle cx="56.5974" cy="62.1013" r="56.1013" fill="#707070" />
      <path
        d="M35.1266 66.4533C32.5123 66.4594 29.77 64.3657 27.8427 62.8144C24.2773 59.9439 21.5331 56.1899 19.9061 51.9578C18.8533 49.218 20.2205 46.1437 22.9597 45.0908C25.6995 44.038 28.7738 45.4052 29.8268 48.1444C32.0929 54.0411 37.0615 56.1929 37.1111 56.2126C39.8312 57.3145 41.1432 60.413 40.0414 63.1331C39.2056 65.1953 37.2226 66.4484 35.1266 66.4533Z"
        fill="#EFEDEE"
      />
      <path
        d="M77.2671 74.7646C79.6826 75.7628 83.0146 74.8673 85.3866 74.1641C89.7749 72.8624 93.7397 70.4318 96.8518 67.1345C98.8662 64.9997 98.7688 61.6365 96.634 59.6222C94.4998 57.608 91.1366 57.7054 89.1224 59.8396C84.7862 64.4339 79.3733 64.5379 79.3199 64.5374C76.3851 64.5238 73.9948 66.892 73.9812 69.8267C73.9707 72.0517 75.3299 73.9641 77.2671 74.7646Z"
        fill="#EFEDEE"
      />
      <path
        d="M89.184 72.7056L92.0333 58.2605C90.9569 58.456 89.9307 58.9839 89.1223 59.8405C84.7862 64.4348 79.3734 64.5382 79.3198 64.5383C76.3851 64.5247 73.9947 66.8929 73.9812 69.8276C73.9706 72.0526 75.3299 73.965 77.2664 74.7654C79.6825 75.7637 83.0145 74.8682 85.3865 74.165C86.6945 73.7773 87.963 73.2866 89.184 72.7056Z"
        fill="#D4D4D4"
      />
      <path
        d="M37.1105 56.2128C37.0609 56.1925 32.0929 54.0414 29.8267 48.1447C29.4036 47.0452 28.6553 46.1673 27.7337 45.5777L24.8844 60.0228C25.7933 61.024 26.7806 61.959 27.8428 62.8141C29.77 64.3654 32.5123 66.4597 35.1266 66.453C37.2227 66.4481 39.2063 65.1951 40.0414 63.1328C41.1426 60.4132 39.8305 57.3147 37.1105 56.2128Z"
        fill="#D4D4D4"
      />
      <g filter="url(#filter0_ddd)">
        <path
          d="M66.5652 18.0449C51.4279 15.059 36.7358 24.9094 33.75 40.0467L25.622 81.2523C25.1708 83.5398 25.9423 85.8972 27.6594 87.4755C29.5977 89.2581 32.2298 89.9921 34.7608 89.0569C37.118 88.1857 39.7638 88.7076 41.6131 90.4085C43.4629 92.1095 46.1087 92.6313 48.4653 91.7601C50.8218 90.8888 53.4677 91.4107 55.3175 93.1117C57.1667 94.8126 59.8125 95.3345 62.1697 94.4633C64.5263 93.5921 67.1721 94.114 69.0213 95.8148C70.9914 97.6261 73.7407 97.9548 76.1925 97.0488C78.3791 96.2405 79.988 94.3526 80.4392 92.0651L88.5671 50.8595C91.553 35.7222 81.7025 21.0308 66.5652 18.0449Z"
          fill="#EFEDEE"
        />
      </g>
      <path
        d="M32.4008 88.4114C30.6839 86.8325 29.9124 84.4751 30.3636 82.1876L38.4915 40.982C41.3198 26.6435 54.651 17.0508 68.9156 18.6156C68.1474 18.3944 67.364 18.2025 66.5652 18.0449C51.4279 15.059 36.7358 24.9094 33.75 40.0467L25.6222 81.2517C25.1708 83.5398 25.9423 85.8972 27.6594 87.4755C29.3173 89.0004 31.4823 89.7569 33.6577 89.3591C33.2147 89.0893 32.7935 88.7722 32.4008 88.4114Z"
        fill="#D4D4D4"
      />
      <path
        d="M71.6957 55.1092C71.0413 54.9801 70.6149 54.345 70.7441 53.69L71.2617 51.0663C71.3907 50.4119 72.0264 49.9857 72.6809 50.1147C73.3353 50.2438 73.7615 50.8795 73.6324 51.5339L73.1149 54.1576C72.9857 54.8126 72.3501 55.2383 71.6957 55.1092Z"
        fill="#3A484A"
      />
      <path
        d="M72.6645 58.5506L69.4931 57.925C68.8387 57.7959 68.4124 57.1602 68.5415 56.5058C68.6706 55.8514 69.3063 55.4251 69.9607 55.5542L73.1321 56.1798C73.7871 56.309 74.2128 56.9446 74.0837 57.599C73.9546 58.2534 73.3195 58.6798 72.6645 58.5506Z"
        fill="#F98084"
      />
      <path
        d="M47.7441 50.3845C47.0897 50.2554 46.6633 49.6203 46.7925 48.9653L47.3101 46.3416C47.4391 45.6872 48.0749 45.261 48.7293 45.3901C49.3843 45.5193 49.8099 46.1549 49.6808 46.8093L49.1633 49.4329C49.0341 50.088 48.3991 50.5137 47.7441 50.3845Z"
        fill="#3A484A"
      />
      <path
        d="M48.7133 53.8259L45.5419 53.2003C44.8869 53.0711 44.4613 52.4356 44.5903 51.7811C44.7194 51.1267 45.3545 50.7004 46.0095 50.8296L49.181 51.4551C49.8354 51.5842 50.2616 52.2199 50.1325 52.8743C50.0034 53.5288 49.3677 53.955 48.7133 53.8259Z"
        fill="#F98084"
      />
      <path
        d="M59.1292 55.7427C57.9522 55.5105 56.9438 54.7992 56.3613 53.7909C56.0276 53.2132 56.2257 52.4741 56.8039 52.1405C57.3815 51.8068 58.1207 52.0049 58.4543 52.5831C58.6878 52.9871 59.1042 53.2747 59.5968 53.3719C60.0894 53.4691 60.5839 53.3611 60.9533 53.076C61.4815 52.6678 62.2399 52.7651 62.6481 53.2933C63.0557 53.8213 62.9583 54.5804 62.4303 54.988C61.5091 55.6997 60.3062 55.9748 59.1292 55.7427Z"
        fill="#3A484A"
      />
    </g>
    <defs>
      <filter
        id="filter0_ddd"
        x="3.49536"
        y="0.511459"
        width="107.605"
        height="126.024"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy="7" />
        <feGaussianBlur stdDeviation="4" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy="5" />
        <feGaussianBlur stdDeviation="11" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow"
          result="effect2_dropShadow"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy="12" />
        <feGaussianBlur stdDeviation="8.5" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
        />
        <feBlend
          mode="normal"
          in2="effect2_dropShadow"
          result="effect3_dropShadow"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect3_dropShadow"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
</template>
<script>
export default {
  name: 'AbsentUsersEmpty'
}
</script>
